module.exports = __webpack_public_path__ + "media/images/v2/resi_logo-3e6f0e3306c99016b3b7ce06c0e88a87.png";